import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/xnadinaver.com/kkumhyeonProjects/넘선생/넘선생_개발/node_modules/next/dist/client/link.js");
